const forgot_password = {
  current_password: 'Current password',
};

export default forgot_password;
